<div class="flex-column gap-M fix-select-height pad-L">
	<!-- GENERAL PANEL -->
	<div class="expansion-panel">
		<div class="flex-align-center flex-space-between pad-M" style="border-radius: 10px;">
			<div class="font-MM fw-700 primary">{{'menu.general'|translate}}</div>
		</div>
		<div class="pad-M">
			<app-application-setting-general></app-application-setting-general>
		</div>
	</div>
	<!-- USAGE PANEL -->
	<div class="expansion-panel">
		<app-application-setting-usage></app-application-setting-usage>
	</div>

	<div class="expansion-panel">
		<div class="flex-align-center flex-space-between pad-M" style="border-radius: 10px;">
			<div class="font-MM fw-700 primary">{{ 'page.appDetails.settings.extensionVisibility' | translate }}</div>
			<app-toggle-button
				*ngIf="initialized"
				[tooltip]="'page.appDetails.settings.extensionVisibilityTooltip' | translate"
				[tooltipDisabled]="extensionSettings.applicationDisplayActivated"
				(click)="goToTenantSettings()"
				[locked]="!extensionSettings.applicationDisplayActivated"
				[toggleInput]="displayExtensionControl"></app-toggle-button>
		</div>
		<div class="pad-M" style="padding-top: 0;">
			<div class="flex-column gap-XS">
				<span>{{ 'page.appDetails.settings.extensionVisibilitySubtitle' | translate }}</span>
			</div>
			<div class="flex-align-center gap-S mt-s">
				<img src="assets/icons/attention.svg" height="14" width="14" alt=""/>
				<span class="orange-text">{{ 'page.appDetails.settings.extensionVisibility1' | translate }} <a (click)="goToSettings()" class="accent" style="text-decoration: underline">{{ 'page.appDetails.settings.extensionVisibility2' | translate }}</a> {{ 'page.appDetails.settings.extensionVisibility3' | translate }}</span>
			</div>
		</div>
	</div>
</div>
